import {Async, Loaded, Loading} from 'Core/models/Async';

export class UnassignedOccupation {
  public static create(occupation: string) {
    return new UnassignedOccupation(occupation);
  }

  public readonly key = 'UnassignedOccupation';
  constructor(public readonly occupation: string) {}
}

export class UserAssignedOccupation {
  public static create(occupation: string, code: string, description: string, underwritingcode: string) {
    return new UserAssignedOccupation(occupation, code, description, underwritingcode);
  }

  public readonly key = 'UserAssignedOccupation';
  constructor(
    public readonly occupation: string,
    public readonly code: string,
    public readonly description: string,
    public readonly underwritingcode: string
  ) {}
}

export class OccupationError {
  public static create(occupation: string) {
    return new OccupationError(occupation);
  }

  public readonly key = 'OccupationError';
  constructor(public readonly occupation: string) {}
}

export type Occupation = Async<string> | UnassignedOccupation | UserAssignedOccupation | OccupationError;

type MatchOccupationOptions<TReturn> = {
  Loading: () => TReturn;
  Loaded: (occupation: string) => TReturn;
  Error: () => TReturn;
  Unassigned: (occupation: string) => TReturn;
  UserAssignedOccupation: (occupation: string, code: string, description: string, underwritingcode: string) => TReturn;
  OccupationError: (occupation: string) => TReturn;
};

export const isLoading = (occupation: Occupation): occupation is Loading<string> => occupation.key === 'Loading';

export const isLoaded = (occupation: Occupation): occupation is Loaded<string> => occupation.key === 'Loaded';

export const isOccupationError = (occupation: Occupation): occupation is OccupationError =>
  occupation.key === 'OccupationError';

export const matchOccupation = <TReturn>(options: MatchOccupationOptions<TReturn>) => (occupation: Occupation) => {
  switch (occupation.key) {
    case 'UnassignedOccupation':
      return options.Unassigned(occupation.occupation);
    case 'Loaded':
      return options.Loaded(occupation.Data);
    case 'Loading':
      return options.Loading();
    case 'Conflict':
      return options.Error();
    case 'ServerError':
      return options.Error();
    case 'Unauthorized':
      return options.Error();
    case 'UserAssignedOccupation':
      return options.UserAssignedOccupation(
        occupation.occupation,
        occupation.code,
        occupation.description,
        occupation.underwritingcode
      );
    case 'OccupationError':
      return options.OccupationError(occupation.occupation);
  }
};
